var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66751 4.41016H3.83249C2.54999 4.41016 1.5 5.46015 1.5 6.74265V15.2627C1.5 16.3502 2.28 16.8151 3.2325 16.2826L6.17999 14.6401C6.49499 14.4676 7.005 14.4676 7.3125 14.6401L10.26 16.2826C11.2125 16.8151 11.9925 16.3502 11.9925 15.2627V6.74265C12 5.46015 10.95 4.41016 9.66751 4.41016Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.74265V15.2627C12 16.3502 11.22 16.8076 10.2675 16.2826L7.32001 14.6401C7.00501 14.4676 6.49499 14.4676 6.17999 14.6401L3.2325 16.2826C2.28 16.8076 1.5 16.3502 1.5 15.2627V6.74265C1.5 5.46015 2.54999 4.41016 3.83249 4.41016H9.66751C10.95 4.41016 12 5.46015 12 6.74265Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3.83249V12.3525C16.5 13.44 15.72 13.8975 14.7675 13.3725L12 11.8275V6.74249C12 5.45999 10.95 4.41 9.66751 4.41H6V3.83249C6 2.54999 7.04999 1.5 8.33249 1.5H14.1675C15.45 1.5 16.5 2.54999 16.5 3.83249Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.cb23f8ed8d7bb5a888483743a5fcf110.svg";
export { ForwardRef as ReactComponent };